/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRoleDto,
  CreateRoleResponseDto,
  GetRoleByIdResponseDto,
  GetRoleListPaginatedParams,
  GetRoleListPaginatedResponseDto,
  UpdateRoleRequestDto,
  UpdateRoleResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Create a new role
 */
export const createRole = (
    createRoleDto: CreateRoleDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CreateRoleResponseDto>(
      {url: `/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRoleDto, signal
    },
      options);
    }
  


export const getCreateRoleMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext> => {

const mutationKey = ['createRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRole>>, {data: CreateRoleDto}> = (props) => {
          const {data} = props ?? {};

          return  createRole(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createRole>>>
    export type CreateRoleMutationBody = CreateRoleDto
    export type CreateRoleMutationError = null | null | null

    /**
 * @summary Create a new role
 */
export const useCreateRole = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRole>>,
        TError,
        {data: CreateRoleDto},
        TContext
      > => {

      const mutationOptions = getCreateRoleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get roles
 */
export const getRoleListPaginated = (
    params: GetRoleListPaginatedParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetRoleListPaginatedResponseDto>(
      {url: `/roles`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRoleListPaginatedQueryKey = (params?: GetRoleListPaginatedParams,) => {
    return [`/roles`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRoleListPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getRoleListPaginated>>, TError = null>(params: GetRoleListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoleListPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoleListPaginated>>> = ({ signal }) => getRoleListPaginated(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoleListPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoleListPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getRoleListPaginated>>>
export type GetRoleListPaginatedQueryError = null


export function useGetRoleListPaginated<TData = Awaited<ReturnType<typeof getRoleListPaginated>>, TError = null>(
 params: GetRoleListPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleListPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getRoleListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoleListPaginated<TData = Awaited<ReturnType<typeof getRoleListPaginated>>, TError = null>(
 params: GetRoleListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleListPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getRoleListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoleListPaginated<TData = Awaited<ReturnType<typeof getRoleListPaginated>>, TError = null>(
 params: GetRoleListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get roles
 */

export function useGetRoleListPaginated<TData = Awaited<ReturnType<typeof getRoleListPaginated>>, TError = null>(
 params: GetRoleListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleListPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Delete a role by ID
 */
export const deleteRoleById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/roles/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRoleByIdMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoleById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRoleById>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteRoleById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRoleById>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRoleById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoleByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRoleById>>>
    
    export type DeleteRoleByIdMutationError = null | null | null

    /**
 * @summary Delete a role by ID
 */
export const useDeleteRoleById = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoleById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRoleById>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteRoleByIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update role
 */
export const updateRole = (
    id: string,
    updateRoleRequestDto: UpdateRoleRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateRoleResponseDto>(
      {url: `/roles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRoleRequestDto
    },
      options);
    }
  


export const getUpdateRoleMutationOptions = <TError = null | null | null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleRequestDto}, TContext> => {

const mutationKey = ['updateRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRole>>, {id: string;data: UpdateRoleRequestDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRole(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>
    export type UpdateRoleMutationBody = UpdateRoleRequestDto
    export type UpdateRoleMutationError = null | null | null | null | null

    /**
 * @summary Update role
 */
export const useUpdateRole = <TError = null | null | null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRole>>,
        TError,
        {id: string;data: UpdateRoleRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateRoleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get role by ID
 */
export const getRoleById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetRoleByIdResponseDto>(
      {url: `/roles/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRoleByIdQueryKey = (id?: string,) => {
    return [`/roles/${id}`] as const;
    }

    
export const getGetRoleByIdQueryOptions = <TData = Awaited<ReturnType<typeof getRoleById>>, TError = null | null>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoleByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoleById>>> = ({ signal }) => getRoleById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoleById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoleByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRoleById>>>
export type GetRoleByIdQueryError = null | null


export function useGetRoleById<TData = Awaited<ReturnType<typeof getRoleById>>, TError = null | null>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleById>>,
          TError,
          Awaited<ReturnType<typeof getRoleById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoleById<TData = Awaited<ReturnType<typeof getRoleById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleById>>,
          TError,
          Awaited<ReturnType<typeof getRoleById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoleById<TData = Awaited<ReturnType<typeof getRoleById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get role by ID
 */

export function useGetRoleById<TData = Awaited<ReturnType<typeof getRoleById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoleById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



